import React from 'react';
interface ImagePlaceholderProps {
  number: number;
  description: string;
  aspectRatio?: 'video' | 'square' | 'auto';
  className?: string;
}
export function ImagePlaceholder({
  number,
  description,
  aspectRatio = 'auto',
  className = ''
}: ImagePlaceholderProps) {
  const aspectClass = aspectRatio === 'video' ? 'aspect-video' : aspectRatio === 'square' ? 'aspect-square' : '';
  return <div className={`bg-sage border-2 border-dashed border-accent p-6 min-h-[200px] flex flex-col items-center justify-center text-center ${aspectClass} ${className}`} data-id="element-253">
      <span className="text-[10px] uppercase font-bold text-accent tracking-[0.2em] mb-2" data-id="element-254">
        IMAGEN ESTRATÉGICA #{number}
      </span>
      <p className="text-[13px] italic text-muted max-w-[280px]" data-id="element-255">
        {description}
      </p>
    </div>;
}